import { render, staticRenderFns } from "./RestoreItemModal.vue?vue&type=template&id=3334c780&"
import script from "./RestoreItemModal.vue?vue&type=script&lang=js&"
export * from "./RestoreItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports